
import {
  Component, Vue, Watch, Prop
} from 'vue-property-decorator';

@Component({
  name: 'Regular'
})

export default class extends Vue {
    dialogVisible: boolean = false
}

